import Gen3IndoorSvg from '@/assets/Gen3-Indoor.svg'
import Gen3OutdoorSvg from '@/assets/Gen3-Outdoor.svg'
import LegacySensorSvg from '@/assets/Legacy-Sensor.svg'
import NoSensorDetails from '@/assets/no-sensor-details.png'

export const models = Object.freeze({
  GEN3_INDOOR: 'Gen3 Indoor',
  GEN3_OUTDOOR: 'Gen3 Outdoor',
  LEGACY_GEN2: 'Legacy Gen2',
  UNKNOWN: 'Unknown',
})

export const signals = Object.freeze({
  UNAVAILABLE: 'UNAVAILABLE',
  WEAK: 'WEAK',
  FAIR: 'FAIR',
  GOOD: 'GOOD',
  STRONG: 'STRONG',
})

export const connections = Object.freeze({
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  INACTIVE: 'INACTIVE',
})

export const getSignalStrength = ({ style, RSSI }) => {
  switch (style) {
    case 'indoor': {
      if (RSSI < -68) return signals.WEAK
      if (RSSI >= -68 && RSSI < -60) return signals.FAIR
      if (RSSI >= -60 && RSSI < -50) return signals.GOOD
      if (RSSI >= -50) return signals.STRONG
      return signals.UNAVAILABLE
    }
    case 'outdoor': {
      if (RSSI < -100) return signals.WEAK
      if (RSSI >= -100 && RSSI < -85) return signals.FAIR
      if (RSSI >= -85 && RSSI < -75) return signals.GOOD
      if (RSSI >= -75) return signals.STRONG
      return signals.UNAVAILABLE
    }
    default: return signals.UNAVAILABLE
  }
}

export const getModel = ({ style, generation }) => {
  if (style && generation) {
    if (style === 'indoor' && generation === 3) return models.GEN3_INDOOR
    if (style === 'outdoor' && generation === 3) return models.GEN3_OUTDOOR
  }
  if (generation === 2) return models.LEGACY_GEN2
  return models.UNKNOWN
}

export const getConnectionColor = ({ connection }) => {
  switch (connection) {
    case connections.ONLINE: return '#33A08E'
    case connections.OFFLINE: return 'error'
    case connections.INACTIVE:
    default:
      return 'secondary'
  }
}

export function getSensorDisplay ({ model }) {
  switch (model) {
    case models.GEN3_INDOOR: return { imagePlaceholder: Gen3IndoorSvg, type: 'Indoor' }
    case models.GEN3_OUTDOOR: return { imagePlaceholder: Gen3OutdoorSvg, type: 'Outdoor' }
    case models.LEGACY_GEN2: return { imagePlaceholder: LegacySensorSvg, type: 'Legacy Sensor' }
    case models.UNKNOWN:
    default: return { imagePlaceholder: NoSensorDetails, type: 'No Sensor Details' }
  }
}

export function getSignalDisplay ({ loading, signal }) {
  if (loading) return { text: 'Fetching Signal...', icon: '$faSpinner', color: '#535353' }
  switch (signal) {
    case signals.WEAK: return { text: 'Weak Signal', icon: '$faSignalAlt1', color: 'error' }
    case signals.FAIR: return { text: 'Fair Signal', icon: '$faSignalAlt2', color: 'warning' }
    case signals.GOOD: return { text: 'Good Signal', icon: '$faSignalAlt3', color: '#0072B2' }
    case signals.STRONG: return { text: 'Strong Signal', icon: '$faSignalAlt', color: '#33A08E' }
    case signals.UNAVAILABLE:
    default: return { text: 'Unavailable' }
  }
}
